var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.policyComponent,{tag:"component",staticClass:"container privacy-policy my-3 my-md-5"})}
var staticRenderFns = []

export { render, staticRenderFns }